export default __webpack_public_path__ + "assets/images/logo_3.fcfe60.png";